import { authSessionStore } from "./auth-session.store";
import { authFormsStore } from "./auth-forms.store";

const bindValue = (store, value) =>
  typeof value === "function" ? value.bind(store) : value;

const getFromStores = (prop) => {
  if (prop in authFormsStore) {
    return bindValue(authFormsStore, authFormsStore[prop]);
  }
  if (prop in authSessionStore) {
    return bindValue(authSessionStore, authSessionStore[prop]);
  }
  return undefined;
};

export const authStore = new Proxy(
  {},
  {
    get(_target, prop) {
      return getFromStores(prop);
    },
    set(_target, prop, value) {
      if (prop in authFormsStore) {
        authFormsStore[prop] = value;
        return true;
      }
      if (prop in authSessionStore) {
        authSessionStore[prop] = value;
        return true;
      }
      return false;
    },
    has(_target, prop) {
      return prop in authFormsStore || prop in authSessionStore;
    },
    ownKeys() {
      return Array.from(
        new Set([
          ...Reflect.ownKeys(authFormsStore),
          ...Reflect.ownKeys(authSessionStore),
        ]),
      );
    },
    getOwnPropertyDescriptor(_target, prop) {
      if (prop in authFormsStore) {
        return Object.getOwnPropertyDescriptor(authFormsStore, prop);
      }
      if (prop in authSessionStore) {
        return Object.getOwnPropertyDescriptor(authSessionStore, prop);
      }
      return undefined;
    },
  },
);
